import { render, staticRenderFns } from "./yesTransferTable.vue?vue&type=template&id=39cad3f3"
import script from "./yesTransferTable.vue?vue&type=script&lang=js"
export * from "./yesTransferTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports